import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "How it works", href: "#flow" },
  { label: "Reader", href: "#demo" },
  { label: "Features", href: "#features" },
  { label: "Languages", href: "#languages" },
  // { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export const Nav = ({ onCta }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass" : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-16">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2.5"
        >
          <span className="w-2.5 h-2.5 rounded-full bg-[var(--vb-primary)] shadow-[0_0_16px_rgba(95,168,255,0.7)]" />
          <span className="font-display font-extrabold text-xl tracking-tight">
            Verbatim
          </span>
          <span className="mono-label hidden sm:inline ml-1.5 !text-[10px]">
            beta
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-[var(--vb-muted)] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {/* <button
            data-testid="nav-signin"
            className="hidden sm:inline text-sm text-[var(--vb-muted)] hover:text-white transition-colors"
          >
            Sign in
          </button> */}
          <button
            data-testid="nav-cta"
            onClick={onCta}
            className="btn-primary !py-2 !px-4 text-sm"
          >
            Join waitlist
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-white"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-white/5" data-testid="mobile-menu">
          <div className="container-x py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-[var(--vb-muted)] hover:text-white py-2"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
